import script from "./AlbumList.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumList.vue?vue&type=script&setup=true&lang=js"

import "./AlbumList.vue?vue&type=style&index=0&id=645a98e0&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-645a98e0"]])

export default __exports__